/**
 * Shared MUI `sx` overrides for Activity Bar menus.
 *
 * Ensures MUI Menu/MenuItem components inherit the app's CSS custom-property
 * font stack rather than Roboto, and use the correct text size token.
 */

/** Paper sx — apply to `slotProps.paper.sx` on <Menu>. */
export const menuPaperSx = {
    fontFamily: "var(--font-family-primary)",
    fontSize: "var(--text-sm, 0.875rem)",
};

/** MenuItem sx — apply to the `sx` prop on <MenuItem>. */
export const menuItemSx = {
    fontFamily: "var(--font-family-primary)",
    fontSize: "var(--text-sm, 0.875rem)",
    gap: "8px",
};
